// import { PublicClientApplication } from '@azure/msal-browser';
// Development Server
// const API_BASE_URL = "https://tektime-mo.digitalisolutions.net/api";
// const API_BASE_URL = "https://phplaravel-1350509-4993140.cloudwaysapps.com/api";
const API_BASE_URL = "https://tektime.ilt-itsolution.com/api";
// const Assets_URL = "https://tektime-mo.digitalisolutions.net/";
const Assets_URL = "https://tektime-storage.s3.eu-north-1.amazonaws.com";

const Client_URL = "https://tektime-admin-eight.vercel.app"; //for Admin Tektime
// const Client_URL = "http://localhost:3000"; //for local Tektime

// const NODE_API = `https://file.tektime.io/api/upload`;
//NODE_API(CLOUDINARY)
const NODE_API = `https://tektime-cloudinary-api.onrender.com/api/upload`;
//CLOUDINARY_API(FRONTEND)
const Cloudinary_URL = 'https://api.cloudinary.com/v1_1/drrk2kqvy/upload'

// Stage Server
// const API_BASE_URL = "https://stage-tektime.digitalisolutions.net/api"
// const Assets_URL = "https://stage-tektime.digitalisolutions.net/";

// Production Server
// const API_BASE_URL = "https://api.tektime.io/api";
// const Assets_URL = "https://api.tektime.io/";

const CLIENT_ID = "e5a1a99f-9e33-4e5d-a7a9-1e2b1d9c36fa"; //Official Id
// const REDIRECT_URI = "http://localhost:3000/auth/callback"; //For Localhost
const REDIRECT_URI = "https://tektime-admin-eight.vercel.app/"; //for Admin Tektime

// MSAL configuration
// export const msalConfig = {
//   auth: {
//     clientId: 'e5a1a99f-9e33-4e5d-a7a9-1e2b1d9c36fa', // Register your app in Azure AD to get this
//     authority: 'https://login.microsoftonline.com/common', // For multi-tenant
//     redirectUri: window.location.origin,
//   },
//   cache: {
//     cacheLocation: 'sessionStorage', // or 'localStorage'
//     storeAuthStateInCookie: false,
//   }
// };

// MSAL configuration
export const msalConfig = {
  auth: {
    clientId: 'e5a1a99f-9e33-4e5d-a7a9-1e2b1d9c36fa', // Replace with your Azure AD client ID
    authority: 'https://login.microsoftonline.com/common', // Or your tenant ID
    redirectUri: window.location.origin, // Must match the redirect URI in Azure AD
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage', // Or 'localStorage' if preferred
    storeAuthStateInCookie: false,
  },
  system: {
    allowRedirectInIframe: true, // Required for PKCE in some scenarios
  },

};

// Create the MSAL instance
// export const msalInstance = new PublicClientApplication(msalConfig);

// // Initialize MSAL
// export const initializeMsal = async () => {
//   try {
//     await msalInstance.initialize();
//     console.log('MSAL initialized successfully');
//   } catch (error) {
//     console.error('MSAL initialization failed:', error);
//   }
// };
export { API_BASE_URL, Assets_URL, NODE_API, Cloudinary_URL, CLIENT_ID, REDIRECT_URI,Client_URL };